import { render } from "./OverlayHost.vue?vue&type=template&id=0242c270&scoped=true"
import script from "./OverlayHost.vue?vue&type=script&lang=js"
export * from "./OverlayHost.vue?vue&type=script&lang=js"

import "./OverlayHost.vue?vue&type=style&index=0&id=0242c270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0242c270"]])

export default __exports__